export default __webpack_public_path__ + "static/media/earthling_2.c9afa7cf.png";